// extracted by mini-css-extract-plugin
export default {"reportContainer":"TotalReports_reportContainer__s0j7e","reports":"TotalReports_reports__jeZJQ","animatedNum":"TotalReports_animatedNum__kBnXY"};